<template>
  <div>
  <modal name="modal-termsandcondition" height="auto" width="512px" :clickToClose="false" class="modal-page" :adaptive="true">
    <i @click="close" v-if="!iconClose" class="close-icon"></i>
    <a @click="close" v-if="iconClose" class="ui basic button close">Close</a>
    <div class="ui grid container modal-summary terms">
      <div class="headertxt">
        <h4>Terms and Conditions</h4>
      </div>
      <div class="details terms">
        <div class="paragraph">
          <label>Statement of Policy</label>
          <p>
            This payment facility is made available to you by Oriente Express Techsystem Corporation doing business under the name and style as CASHALO (“OETC” or the “Company”) in conjunction with Xendit Philippines Inc. , an operator of payment systems duly registered with the Bangko Sentral ng Pilipinas with registration no. OPSCOR-2020-0100 (“XENDIT” or the “Payment Gateway Provider”).
          </p>
          <p>
            The payment facility allows users of the Cashalo Platform (Cashalo mobile App, Cashalo Website and other Company services) to use the payment gateway services provided by XENDIT which allows you (the user of the Service) to access and use your bank account, electronic wallet or similar fund sources to make payments for any bills, loan and/or other obligations, in your name, or in the name of any other party for which such payments are made.
          </p>

          <p>
            We value your privacy and we are committed to the protection of any and all personal information which you may provide when using this Cashalo Online Repayment website (the “Website”), in compliance with Republic Act No. 10173 or the Data Privacy Act of 2012.
          </p>

          <p>
            In this privacy policy, we inform you (1) what personal information is collected from you; (2) how we collect and protect your personal information; (3) why we are collecting your personal information;  and (4) upon your further consent if so required, to whom we share your personal information and for what purpose.
          </p>
        </div>

        <div class="paragraph">
          <label>PERSONAL INFORMATION COLLECTED AND HANDLED</label>
          <p>We collected the following information:</p>

          <p>
            •	Loan ID <br>
            •	Mobile Number <br>
            •	Payment Amount <br>
          </p>
          <p>
            Your Bank (i.e. Bank of Philippine Islands), E-Wallet, or other fund source provider may, as applicable, share the following information :
          </p>

          <p>• Bank Account Details limited to Account number and type</p>
          <p>collectively “Third Party Account Information” </p>
          <p>
            The sharing and receipt by OETC of any Third Party Account Information is subject to terms and conditions you have signed and accepted with the Bank, E-Wallet or other fund source provider. Any questions, clarifications may be directed to their respective data privacy officer. Any clarifications with respect to access to your account as a fund source may be directed to:
          </p>


          <table class="ui celled unstackable table">
            <thead>
              <tr>
                <th>Fund Source Provider</th>
                <th>Service</th>
                <th>Contact Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Bank of Philippine Islands</td>
                <td>BPI Online</td>
                <td>
                  <div class="ui list">
                    <div class="item">Name: Data Privacy Officer</div>
                    <div class="item">Contact Information: dpo@cashalo.com</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <p>
            Once you have selected the bank, electronic wallet, or other fund source provider, as required by the source fund, you will be redirected to the Service managed by the Fund Source Provider to confirm your credentials. PLEASE BE REMINDED THAT YOU ACCESS TO THE SERVICE OF THE FUND SOURCE PROVIDER IS SUBJECT TO SEPARATE TERMS AND CONDITIONS BY SUCH PROVIDER. Read the terms and conditions carefully before you proceed.
          </p>

          <p>
            We also collect the above personal information from you when you send us inquiries at hello@cashalo.com
          </p>
        </div>

        <div class="paragraph">
          <label>USE/PURPOSE</label>
          <p>The Personal Information is collected, processed, used, disclosed, stored and retained for the following purposes: </p>

          <div class="ui bulleted list">
            <div class="item">
              To identify Users of the Website;
            </div>
            <div class="item">
              To receive the details of your payment instruction, in particular the loan to which the payment is to be credit, the amount to be credited, the source of funds, and the mobile number of the loan account holder;
            </div>
            <div class="item">
              To submit your payment request to the Payment Gateway Provider;
            </div>
            <div class="item">
              To process and submit your payment request to the bank, electronic wallet or other fund source provider to allow you to access your account and to submit payment instructions;
            </div>
            <div class="item">
              Information you provided will be recorded and retained in our system logs to records your request, and consummation of your transaction request;
            </div>
            <div class="item">
              Your information and the record of transactions may also be used in case of internal review of your transactions, audit, disputes from you or any third party regarding any of your transactions;
            </div>
            <div class="item">
              We will also use and store your information for legal and regulatory requirements;
            </div>
            <div class="item">
              To communicate with you the products and services;
            </div>
            <div class="item">
              We may use your information and may reach out to you for market research, statistical analyses, or other research to improve the Company’s products and services, and customer satisfaction analysis;
            </div>
            <div class="item">
              To respond to the Users in relation to inquiries sent hello@cashalo.com
            </div>
          </div>


        </div>

        <div class="paragraph">
          <label>SHARING OF PERSONAL INFORMATION</label>
          <p>
            Your Personal Information may be shared by the Company with its assigns, affiliates, and related companies (the “Oriente Group”) in the conduct of its business for processing as may be required in the maintenance and performance of its business activities.
          </p>
          <p>
            The Oriente Group may, as necessary, be engaged by the Company as subcontractors or data processors in each case with respect to the purposes enumerated above.
          </p>
          <p>
            Your Personal Information will also be shared with the Payment Gateway Provider for the purpose of facilitating the payment transactions.
          </p>
          <p>
            Your Personal Information will also be shared with the Fund Source Provider (i.e. Bank of Philippine Islands) to the extent necessary to allow you to access your account and use the same to implement your payment transaction.
          </p>
          <p>
            All data processing, subcontracting or data sharing agreements will be in accordance with the requirements under the Data Privacy Act of 2012, or applicable laws and regulations. To the extent that such processing, subcontracting, or data sharing requires notice or consent, we will provide you notice or request for your consent, in each case, prior to any processing or sharing of your Personal Information.
          </p>
        </div>

        <div class="paragraph">
          <label>RETENTION OF PERSONAL INFORMATION</label>
          <p>
            Your Personal Information will be retained by the Company for as long as needed and necessary to achieve the above-mentioned use/purposes for which it was collected and for such period of time required for legal and regulatory purposes.
          </p>
          <p>
            Your Personal Information will be disposed of in a secure manner that would prevent further processing, unauthorized access or disclosure to any other party or the public, provided that the Company may retain copies of your Personal Information in the Company’s archives pursuant to its bona fide record retention or data back-up policies, access to which shall be restricted on a need-to-know basis, as may be required under the applicable laws and regulations.
          </p>
        </div>

        <div class="paragraph">
          <label>SECURITY OF YOUR PERSONAL INFORMATION  </label>
          <p>
            The Company values your Personal Information collected, used, or stored through the Website, and we will ensure that it is protected from possible threats, both online and offline. The Company has the necessary technical, organizational and physical measures to ensure that your Personal Information is kept safe and secure, as well as to prevent unauthorized access or disclosure of the collected and stored Personal Information.
          </p>
        </div>

        <div class="paragraph">
          <label>LOG DATA</label>
          <p>
            When a User or visitor visits and/or uses the website, the User’s or visitor’s browser/interface may send the Company personal information which the Company collects for statistical and internal record-keeping purposes. The process of collecting this information is called “Log Data”, and may include information such as the computer’s Internet Protocol (IP) address, browser type, browser version, the visited pages of the Website, the time and date of the visit, time spent on the pages, and other statistics.
          </p>
        </div>

        <div class="paragraph">
          <label>COOKIES</label>
          <p>
            A cookie is a small file which asks permission to be placed on the visitor’s computer hard drive. Once the visitor agrees, the file is added and the cookie helps analyze web traffic or provides internet usage information. A visitor can instruct his or her browser to refuse all cookies or to indicate when a cookie is being sent. However, if the visitor does not accept cookies, the visitor may not be able to use some portions of the website. A cookie in no way gives the Company access to the visitor’s computer or any information about the visitor, other than the data the visitor chooses to share with the Company.
          </p>
        </div>

        <div class="paragraph">
          <label>CHANGES IN OUR PRIVACY POLICY</label>
          <p>
            This Privacy Policy is in effect as of ________December 30, 2020____________ and shall continue to remain in effect unless otherwise changed or amended.
          </p>
          <p>
            The Company reserves the right to amend this Privacy Policy from time to time, upon due notification to its Users or visitors.
          </p>
          <p>
            If significant changes to this Privacy Policy will affect certain Personal Information, the Company shall notify its Users through the email address provided or by posting a public notice on the website.
          </p>
        </div>

        <div class="paragraph">
          <label>ACCESS AND CORRECTION OF PERSONAL INFORMATION</label>
          <p>
            You may contact us if you wish to exercise your rights to access, correct, cancel, and object to personal information you have submitted, get a copy of the personal information we have generated, or if you have any inquiries regarding the protection of your personal information.
          </p>
          <p>You may send an email to the following:</p>
          <p>Data Privacy Officer</p>
          <p>dpo@cashalo.com</p>
        </div>

        <div class="paragraph">
          <label>ACCEPTANCE</label>
          <p>
            I confirm having read and understood and agree to the foregoing Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  </modal>
</div>
</template>
<script>

export default {
  name:'modal-termsandcondition',
  data() {
    return {
      bigClose: true,
      iconClose: false
    }
  },
  methods: {
    close() {
      this.$modal.hide('modal-termsandcondition');
    },
    checkwindow() {
      if ($(window).width() >= 800) {
        this.iconClose = true
      } else if ($(window).width() <= 799) {
        !this.iconClose
      }
    }
  },
  mounted() {
    this.checkwindow()
  }
}
</script>
